import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { useUserStore } from '../stores/userStore';

export function useAuthSync() {
  const { user: supabaseUser, loading } = useAuth();
  const { setUser, clearUser } = useUserStore();

  useEffect(() => {
    if (loading) return;

    if (supabaseUser) {
      // Sync Supabase user with user store
      setUser({
        id: supabaseUser.id,
        email: supabaseUser.email!,
        fullName: supabaseUser.user_metadata?.full_name || supabaseUser.email!.split('@')[0],
        avatarUrl: supabaseUser.user_metadata?.avatar_url,
        userType: supabaseUser.user_metadata?.user_type || 'tenant'
      });
    } else {
      // Clear user store if no Supabase user
      clearUser();
    }
  }, [supabaseUser, loading, setUser, clearUser]);

  return { user: supabaseUser, loading };
}
